import type { ModelCertificate } from '@app/api/Certificates';

import type { CertificateFormValues } from '../types';

interface BuildCertificateDataParams {
  values: CertificateFormValues;
  /** ID редактируемого сертификата, null — создание нового */
  certificateId: number | null;
  branchId: number;
}

/** Собирает тело CreateCertificate / EditCertificate из значений формы */
export const buildCertificateData = ({
  values: { Name, Cost },
  certificateId,
  branchId,
}: BuildCertificateDataParams): ModelCertificate => ({
  Id: certificateId ?? 0,
  BranchId: branchId,
  Name: Name.trim(),
  Cost: Number(Cost),
  IsDeleted: false,
});
